'use client'

import React from 'react'
import APIChat from './APIChat'
import { Socket } from 'socket.io-client'
import { AITool } from './types'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Bot, X } from 'lucide-react'

interface AISidebarProps {
  socket: Socket | null
  roomId: string
  userId: string
  tools: AITool[]
  context: any
  onClose: () => void
}

export function AISidebar({
  socket,
  roomId,
  userId,
  tools,
  context,
  onClose
}: AISidebarProps) {
  return (
    <Sidebar 
      side="right" 
      variant="sidebar" 
      collapsible="none" 
      className="h-full w-full border-l-2 flex-shrink-0"
      style={{ 
        width: '24rem',
        borderLeftColor: '#88a1ac',
        minWidth: '24rem',
        maxWidth: '24rem'
      }}
    >
      <SidebarHeader className="border-b border-sidebar-border h-16 flex justify-center flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Bot className="h-6 w-6 text-[#21728d]" />
            <h3 className="text-lg font-semibold text-sidebar-foreground">AI Trading Assistant</h3>
          </div>
          <button
            onClick={onClose}
            className="h-8 w-8 rounded-md flex items-center justify-center hover:bg-sidebar-accent transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </SidebarHeader>
      
      <SidebarContent className="flex-1 h-full overflow-hidden flex flex-col">
        <SidebarGroup className="flex-1 min-h-0 flex flex-col">
          <SidebarGroupLabel className="flex-shrink-0">AI Chat</SidebarGroupLabel>
          <SidebarGroupContent className="flex-1 min-h-0 flex flex-col">
            <div className="h-full min-h-0 flex-1">
              <APIChat
                context={{
                  ...context,
                  contextInfo: {
                    currentSymbol: context.currentSymbol || 'N/A',
                    toolsCount: tools.length
                  }
                }}
                className="h-full"
              />
            </div>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}